import styles from './styles.module.css';
import React from 'react';
import { InfoLink } from 'src/components/infoLink';
import { LinkHelper } from 'src/utils/link-helper';

export const LinkWithDescriptionTemplate = (props: any) => {
	if (!props.data) {
		console.error("LinkWithDescriptionTemplate didn't receive props.data", props);
		return <div></div>;
	}

	const {
		contentful_id,
		linkTitle,
		linkExternalAddress,
		pdfResource,
		shortDescription,
		linkInternalResource,
	} = props.data;

	const getInternalLink = () => {
		if (pdfResource?.file?.url) {
			return pdfResource.file.url;
		}
		if (linkInternalResource) {
			if (linkInternalResource.url) {
				return linkInternalResource.url;
			}
			if (linkInternalResource.internal?.type && linkInternalResource.contentful_id) {
				return LinkHelper.linkTo(linkInternalResource);
			}
		}
		return undefined;
	};

	return (
		<InfoLink
			title={linkTitle}
			link={{
				externalLink: linkExternalAddress,
				internalLink: getInternalLink(),
				isDownload: pdfResource,
			}}
		>
			{shortDescription}
		</InfoLink>
	);
};
